import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Scegli il tuo piano iniziale <br/> Pensiamo a tutto noi, <underline>TU</underline> rilassati 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Paga dopo dalle vendite',
    [BillingMode.Stripe]: '(0)[Paga ora];(1-inf)[Paga ora (risparmia fino a {{discount}})]',
  },
};
